export const ANDROID = window.navigator.userAgent.match(/Android/i);



// WEBPACK FOOTER //
// ./src/pages/Landing/platform.js